export default __webpack_public_path__ + "static/media/hhs-qld-north-west.6dc1a071.svg";